import * as React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'

const eventQuery = graphql`
  {
    gcms {
      activiteiten(where: {datum_gte: now}, stage: PUBLISHED, orderBy: datum_ASC) {
        id
        code
        datum
        geenDatum
        tijd
        titel
        beschrijving
        kosten
        leeftijden
        seizoen
        extrapagina {
          titel
          slug
        }
        externalURL
      }
    }
  }
`;

const Events = () => {
  const {
    gcms: {activiteiten},
  } = useStaticQuery(eventQuery);

  return (
    <div className="event-list">
      {activiteiten.map(({id, ...activiteit}) => (
        <div key={id} className={`event event--${activiteit.seizoen}`}>
        <div className="event__date">
          <span className="weekday">
            {!activiteit.geenDatum && (
              new Intl.DateTimeFormat("nl-NL", {
                weekday: "long"
              }).format(new Date(activiteit.datum))
            )}
            {activiteit.geenDatum && (
              "coming"
            )}
          </span>
          <span className="day">
            {!activiteit.geenDatum && (
              new Intl.DateTimeFormat("nl-NL", {
                day: "2-digit"
              }).format(new Date(activiteit.datum))
            )}
            {activiteit.geenDatum && (
              "??"
            )}
          </span>
          <span className="month">
            {!activiteit.geenDatum && (
              new Intl.DateTimeFormat("nl-NL", {
                month: "long"
              }).format(new Date(activiteit.datum))
            )}
            {activiteit.geenDatum && (
              "soon"
            )}
          </span>
        </div>
        <div className="event__text">
          <div className="event__title">
            <div className="event__name">
              {activiteit.titel}
            </div>
          </div>
          <div className="event__description">
            {activiteit.beschrijving}
          </div>
          <div className="event__meta">
            {activiteit.leeftijden && (            
              <span className="ages">
                {activiteit.leeftijden}
              </span>
            )}  
            {activiteit.tijd && (
              <span className="time">
                {activiteit.tijd}
              </span>
            )}
            {activiteit.kosten && (
              <span className="price">
                {new Intl.NumberFormat('nl-NL', {
                  style: 'currency',
                  currency: 'EUR',
                }).format(activiteit.kosten)}            
              </span>
            )}
            <span className="break" />
            <div class="event__buttons">
              {activiteit.extrapagina && (       
                <Link className="btn" to={`/${activiteit.extrapagina.slug}`}>
                  {activiteit.extrapagina.titel}
                </Link>
              )} 
              {activiteit.code && (              
                <Link className="btn" to={`/aanmelden?activiteit=${activiteit.code}`}>
                  Aanmelden
                </Link>
              )}
              {activiteit.externalURL && (              
                <a className="btn" rel="noreferrer" target="_blank" href={`${activiteit.externalURL}`}>
                  Meer informatie
                </a>
              )}                          
              {activiteit.geenDatum && (       
                <a class="btn" href={`mailto:info@wildkids.nu?subject=Ik%20heb%20interesse%20in%20de%20` + encodeURI(activiteit.titel)}>Interesse tonen</a>
              )}
            </div>
          </div>
        </div>
      </div>
      ))}
    </div>
  )
}

export default Events